import { render, staticRenderFns } from "./LocationEditor.vue?vue&type=template&id=0c6c8d34&scoped=true"
import script from "./LocationEditor.vue?vue&type=script&lang=js"
export * from "./LocationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c8d34",
  null
  
)

export default component.exports